import React from "react";
import { Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import Category from "./pages/Category";
import Blog from "./pages/Blog";
import About from "./pages/About";
import Signs from "./pages/Signs";
import WhatareHarmones from "./pages/WhatareHarmones";
import Hormones from "./pages/Hormones";
import Lifestyle from "./pages/Lifestyle";
import Supplements from "./pages/Supplements";

function App() {
  return (
    <>
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/category/:categoryId" element={<Category />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/about" element={<About />} />
        <Route path="/what-are-hormones" element={<WhatareHarmones />} />
         <Route path="/Signs" element={<Signs/>} />
         <Route path="/Hormones" element={<Hormones/>} />
          <Route path="/Lifestyle" element={<Lifestyle/>} />
           <Route path="/Supplements" element={<Supplements/>} />
      </Routes>

      <Footer />
    </>
  );
}

export default App;
